// Support fix 2026-09-24: one share bar for ATC demands + Sellers Bazaar posts.
// Links always use the site's own domain (anantwebportal.com) and open a public post page,
// so people outside the app can see the post without logging in.
import React from 'react';
import { toast } from 'sonner';

export default function ShareBar({ shareUrl, text, title, imageUrl, label = 'Share:', testPrefix = 'atc-share' }) {
  const full = `${text}\n\n${shareUrl}`;
  const encoded = encodeURIComponent(full);
  const wa = `https://wa.me/?text=${encoded}`;
  const fb = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;
  const stop = (e) => e.stopPropagation();

  const copyLink = async (e) => {
    stop(e);
    try { await navigator.clipboard.writeText(full); toast.success('📋 Link copied'); }
    catch (_) { toast.error('Copy failed'); }
  };
  const nativeShare = async (e) => {
    stop(e);
    if (navigator.share) {
      try { await navigator.share({ title, text, url: shareUrl }); } catch (_) { /* cancelled */ }
    } else { copyLink(e); }
  };
  // Instagram has no web "share link" API: on phones the native share sheet offers Instagram
  // Stories/Direct; for the feed, download the post image and upload it in Instagram.
  const instagram = async (e) => {
    stop(e);
    if (navigator.share) { nativeShare(e); return; }
    await copyLink(e);
    toast('Instagram: paste the link in your Story link sticker, or use "Download image" for a feed post.');
  };
  const downloadImage = async (e) => {
    stop(e);
    if (!imageUrl) return;
    try {
      const r = await fetch(imageUrl);
      const blob = await r.blob();
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = `${(title || 'anant-post').replace(/[^a-z0-9]+/gi, '-').slice(0, 40)}.${(blob.type.split('/')[1] || 'png').split('+')[0]}`;
      document.body.appendChild(a); a.click(); a.remove();
      setTimeout(() => URL.revokeObjectURL(a.href), 2000);
    } catch (_) { window.open(imageUrl, '_blank'); }
  };

  return (
    <div className="flex items-center gap-1.5 flex-wrap pt-1" data-testid={`${testPrefix}-row`} onClick={stop}>
      <span className="text-[10px] font-black opacity-70 uppercase">{label}</span>
      <a href={wa} target="_blank" rel="noopener noreferrer" onClick={stop} data-testid={`${testPrefix}-wa`}
         className="px-2 py-1 rounded bg-green-600 text-white text-[10px] font-black">📱 WhatsApp</a>
      <a href={fb} target="_blank" rel="noopener noreferrer" onClick={stop} data-testid={`${testPrefix}-fb`}
         className="px-2 py-1 rounded bg-blue-600 text-white text-[10px] font-black">📘 Facebook</a>
      <button onClick={instagram} data-testid={`${testPrefix}-ig`}
              className="px-2 py-1 rounded bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500 text-white text-[10px] font-black">📸 Instagram</button>
      <button onClick={copyLink} data-testid={`${testPrefix}-copy`}
              className="px-2 py-1 rounded bg-slate-700 text-white text-[10px] font-black">🔗 Copy link</button>
      {imageUrl && (
        <button onClick={downloadImage} data-testid={`${testPrefix}-download`}
                className="px-2 py-1 rounded bg-slate-700 text-white text-[10px] font-black">⬇️ Download image</button>
      )}
      <button onClick={nativeShare} data-testid={`${testPrefix}-native`}
              className="px-2 py-1 rounded bg-slate-700 text-white text-[10px] font-black">📲 More</button>
    </div>
  );
}
